<template>
  <v-row no-gutters>
    <v-col>
      <v-row>
        <v-toolbar dense flat color="white" height="45px" class="mt-1">
          <v-toolbar-title class="headline primary--text"
            >Pricing Tables</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              text
              :color="
                active == 'adminpricingtableforex'
                  ? 'primary darken-4'
                  : 'primary'
              "
              class="font-weight-bold px-0 mr-2"
              @click="onClick('adminpricingtableforex')"
            >
              <v-icon size="18" class="mr-1">mdi-home-currency-usd</v-icon
              >CURRENCIES
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricinglocalcharges'
                  ? 'primary darken-4'
                  : 'primary'
              "
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminpricinglocalcharges')"
            >
              <v-icon size="18" class="mr-1">mdi-anchor</v-icon>LOCAL
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricingcustoms' ? 'primary darken-4' : 'primary'
              "
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminpricingcustoms')"
            >
              <v-icon size="15" class="mr-1">fa-file-signature</v-icon>CUSTOMS
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricingdgclasses'
                  ? 'primary darken-4'
                  : 'primary'
              "
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminpricingdgclasses')"
            >
              <v-icon size="15" class="mr-1">fa-fire</v-icon>DG CLASSES
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricingfcl' ? 'primary darken-4' : 'primary'
              "
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminpricingfcl')"
            >
              <v-icon size="18" class="mr-1">mdi-ferry</v-icon>FCL
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricinglcl' ? 'primary darken-4' : 'primary'
              "
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminpricinglcl')"
            >
              <v-icon size="15" class="mr-1">fa-box</v-icon>LCL
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricingair' ? 'primary darken-4' : 'primary'
              "
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminpricingair')"
            >
              <v-icon size="18" class="mr-1">mdi-airplane</v-icon>AIR
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricinghaulage' ? 'primary darken-4' : 'primary'
              "
              class="font-weight-bold px-0 mx-2"
              @click="onClick('adminpricinghaulage')"
            >
              <v-icon size="15" class="mr-1">fa-truck-moving</v-icon>HAULAGE
            </v-btn>

            <v-divider vertical inset></v-divider>

            <v-btn
              text
              :color="
                active == 'adminpricingtransport'
                  ? 'primary darken-4'
                  : 'primary'
              "
              class="font-weight-bold px-0 ml-2"
              @click="onClick('adminpricingtransport')"
            >
              <v-icon size="15" class="mr-1">fa-truck</v-icon>TRANSPORT
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-row>

      <v-row>
        <v-divider class="my-0 py-0"></v-divider>
      </v-row>

      <v-row no-gutters>
        <v-col>
          <router-view />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      active: "adminpricingtableforex",
    }
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token()
  },

  mounted() {
    var name = null
    this.$router.push({ name: "adminpricingtableforex" })
  },

  methods: {
    onClick(routeName) {
      this.active = routeName
      var name = null
      this.$router.push({ name: routeName })
    },
  },
}
</script>

<style></style>
